import * as React from 'react';
import * as R from 'ramda';
import Button from '@material-ui/core/Button';
import { withIntl, IntlProps } from 'ha/i18n';
import { priceRange } from '../../utils/formatRanges';

export interface Props {
  priceMin?: number;
  priceMax?: number;
  currency: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  dataTestLocator?: string;
}

export const PriceFilterButton: React.SFC<Props & IntlProps> = ({
  currency,
  priceMin,
  priceMax,
  onClick,
  intl: { T },
  dataTestLocator = 'Price Filter Button',
}) => {
  const isActive = R.is(Number, priceMin) && R.is(Number, priceMax);

  return (
    <Button
      variant={isActive ? 'contained' : 'outlined'}
      color="primary"
      onClick={onClick}
      data-test-locator={dataTestLocator}
    >
      {isActive && priceRange(currency, priceMin, priceMax)}

      {!isActive && T('Price')}
    </Button>
  );
};

export default withIntl(PriceFilterButton);
